<div class="app-container">
  <!-- Top toolbar (always visible) -->
  <mat-toolbar color="primary" class="app-toolbar">
    <mat-icon class="app-icon">card_membership</mat-icon>
    <span class="app-title">MemOwl License</span>
    <span class="spacer"></span>

    @if (isAuthenticated()) {
      <!-- Authenticated user menu -->
      <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
        <mat-icon class="user-icon">account_circle</mat-icon>
        <span class="user-email">{{ userEmail() }}</span>
        <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
      </button>

      <mat-menu #userMenu="matMenu">
        <div class="user-menu-header">
          <mat-icon>person</mat-icon>
          <div class="user-info">
            <div class="user-email-full">{{ userEmail() }}</div>
            <div class="user-status">User</div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Sign Out</span>
        </button>
      </mat-menu>
    } @else {
      <!-- Login button -->
      <button mat-raised-button color="accent" (click)="openLoginDialog()" class="login-button">
        <mat-icon>login</mat-icon>
        <span>Sign In</span>
      </button>
    }
  </mat-toolbar>

  <!-- Main content area - always shows plans (no auth check) -->
  <div class="app-content">
    <ng-content></ng-content>
  </div>
</div>

